import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TFeeClassDetails } from 'redux/reducers/easFee/types';

/** Percentage columns keep their own unit, money columns get the fee class currency injected. */
const percentageColumn = (
	name: string,
	selector: keyof TFeeClassDetails,
	show: boolean,
): TTableStructure<keyof TFeeClassDetails> => ({
	name,
	selector,
	show,
	sortable: false,
	filterable: false,
	colSpan: 1,
	type: ETableStructureType.AMOUNT,
	align: ETableStructureAlign.RIGHT,
	currency: () => '%',
});

const amountColumn = (
	name: string,
	selector: keyof TFeeClassDetails,
	show: boolean,
): TTableStructure<keyof TFeeClassDetails> => ({
	name,
	selector,
	show,
	sortable: false,
	filterable: false,
	colSpan: 1,
	type: ETableStructureType.AMOUNT,
	align: ETableStructureAlign.RIGHT,
});

export const tableStructure: TTableStructure<keyof TFeeClassDetails>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Name',
		selector: 'name',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Automatic',
		selector: 'automatic',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
	},
	amountColumn('Import Fixed Fee', 'importSchemeFixedFee', true),
	percentageColumn('Import %', 'importPercentageFee', true),
	amountColumn('Union Fixed Fee', 'unionFixedFee', true),
	percentageColumn('Union %', 'unionPercentageFee', true),
	amountColumn('Non-Union Fixed Fee', 'nonUnionFixedFee', true),
	percentageColumn('Non-Union %', 'nonUnionPercentageFee', true),
	amountColumn('B2C Domestic Fixed Fee', 'b2cDomesticFixedFee', true),
	percentageColumn('B2C Domestic %', 'b2cDomesticPercentageFee', true),
	amountColumn('FC Rep Fixed Fee', 'fcRepFixedFee', true),
	percentageColumn('FC Rep %', 'fcRepPercentageFee', true),
	amountColumn('Min Trade Value', 'minTradeValue', true),
	amountColumn('Max Trade Value', 'maxTradeValue', true),
	{
		name: 'Min Order Count',
		selector: 'minOrderCount',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Max Order Count',
		selector: 'maxOrderCount',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
			{
				name: 'Delete',
				icon: EIconButtons.DELETE,
			},
		],
	},
];
